import { FallbackLogger } from '@fingermarkglobal/logger';

window.logger = window.logger || new FallbackLogger();

export { useCart, useStage, useSecondaryCart } from './src';
